import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import useMetaLayoutContext from './MetaLayoutContext';
import { useMetaLayoutSubmissionAdder } from './MetaLayoutSubmissionProvider';

// You can wrap a meta form layout in this component so that its submit function enters the submission context
export function MetaLayoutSubmissionScroller({ children, onHighlight: onHighlightProp }) {
  const ref = useRef();
  const onHighlight = useCallback(() => {
    if (ref.current) {
      setTimeout(
        () => ref.current.scrollIntoView(),
        // The way this is used today, onHighlightProp has a <300ms animation that adjusts what we're scrolling significantly, and which we have no way of knowing if it has ended.
        // Adding a 300ms wait will help us avoid some jank but requires a fast device.
        // Adding a 400ms wait will work even on slower devices.
        // TODO: solve properly in PX-17847
        400,
      );
    }
    onHighlightProp();
  }, [onHighlightProp]);

  const { onSubmit } = useMetaLayoutContext();
  useMetaLayoutSubmissionAdder(onSubmit, onHighlight);

  // TODO: support more than just div in PX-17846
  return (
    <div ref={ref}>
      {children}
    </div>
  );
}

MetaLayoutSubmissionScroller.defaultProps = {
  onHighlight: () => {},
};

MetaLayoutSubmissionScroller.propTypes = {
  children: PropTypes.node.isRequired,
  onHighlight: PropTypes.func,
};
